import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/report/sales';

const overview = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/overview`, data);
};

const trend = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/trend`, data);
};

const trendTotal = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/trend-total`, data);
};

const trendExport = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/trend/export`, data, {
		responseType: 'blob',
	});
};

const payment = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/payment`, data);
};

const paymentMethod = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/payment/method`, data);
};

const paymentMethodExport = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/payment/method/export`, data, {
		responseType: 'blob',
	});
};

const paymentTime = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/payment/time`, data);
};

const paymentTimeExport = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/payment/time/export`, data, {
		responseType: 'blob',
	});
};

const proportionCategory = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/proportion/category`, data);
};

const proportionItems = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/proportion/items`, data);
};

const proportionMembership = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/proportion/membership`, data);
};

const proportionPayBy = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/proportion/pay-by`, data);
};

const orderAmount = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/order-amount`, data);
};

const productSales = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/product-sales`, data);
};

const productTotal = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/product-total`, data);
};

const productTrend = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/product-trend`, data);
};

const productSalesExport = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/product-sales/export`, data, {
		responseType: 'blob',
	});
};

const productConsolidate = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/product-consolidate`, data);
};

const productConsolidateExport = (merchantId, data) => {
	return Client.get(
		`${baseUrl}/${merchantId}/product-consolidate/export`,
		data,
		{
			responseType: 'blob',
		}
	);
};

const categorySales = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/category-sales`, data);
};

const categoryTotal = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/category-total`, data);
};

const categoryTrend = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/category-trend`, data);
};

const categorySalesExport = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/category-sales/export`, data, {
		responseType: 'blob',
	});
};

const dashboardSummary = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/summary`, data);
};

const dashboardSummaryBranch = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/summary/branch`, data);
};

const itemGroupSales = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/itemGroup-sales`, data);
};

const itemGroupTotal = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/itemGroup-total`, data);
};

const itemGroupSalesExport = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/itemGroup-sales/export`, data, {
		responseType: 'blob',
	});
};

export default {
	overview,
	trend,
	trendTotal,
	trendExport,
	payment,
	paymentMethod,
	paymentTime,
	paymentTimeExport,
	paymentMethodExport,
	proportionCategory,
	proportionItems,
	proportionMembership,
	proportionPayBy,
	orderAmount,
	productSales,
	productSalesExport,
	productTotal,
	productTrend,
	productConsolidate,
	productConsolidateExport,
	categorySales,
	categoryTotal,
	categoryTrend,
	categorySalesExport,
	dashboardSummary,
	dashboardSummaryBranch,
	itemGroupSales,
	itemGroupTotal,
	itemGroupSalesExport,
};
